<template>
    <div class="dashboard-wrapper">
        <div class="dashboard-head">
            <dashboard-filters/>

            <div class="dashboard-table" style="width:70%">
                <div class="calendar-stats">
                    <div>
                        <p class="calendar-stats__p calendar-stats__booked"> {{$t('metrics.booked')}} <span>100%</span> </p>
                    </div>
                    <div>
                        <p class="calendar-stats__p calendar-stats__workload"> {{$t('metrics.workload')}}  <span >75%</span></p>
                    </div>
                    <div>
                        <p class="calendar-stats__p calendar-stats__discipline" > {{$t('metrics.discipline')}} <span>50%</span></p>
                    </div>
                    <div>
                        <p class="calendar-stats__p calendar-stats__factual"> {{$t('metrics.factual_workload')}} <span>60%</span></p>
                    </div>
                </div>
            </div>
        </div>

        <dashboard/>
    </div>
</template>

<script>
import dashboardFilters from '@/components/filters/dashboard/dashboardFilters'
import dashboard from '@/components/controls/dashboard/dashboard'
import getColor from '@/mixins/getStatisticColors'

export default {
    components: {
        dashboardFilters,
        dashboard,
    },
    mixins: [getColor],
}
</script>
<style lang="scss" scoped>
.dashboard-wrapper {
    width: 100%;
    height: calc(100vh - 70px);
    padding: 12px 30px 0;
    box-sizing: border-box;
    margin-left: auto;
}

.dashboard-head {
    display: flex;
    align-items: flex-end;
    margin-bottom: 12px;
}

.dashboard-head  {
    .calendar {
        &-stats {
            justify-content: flex-end;
        }

        &-stats__p {
            color: rgb(105,105,105);
            margin: 0 0 0 40px;
        }
    }
}
</style>
